import { Injector } from "@angular/core";
import { MeddraNode } from "../MeddraNode";
import { BaseNode } from "../../BaseNode";

export class TreeNodeMeddraLevelItem extends MeddraNode {

    constructor(injector: Injector, data: any, entityName: string, entityNode: BaseNode|null, parent: BaseNode) {
        
        super(injector, data, data.model.name, entityName, entityNode, parent);
    }

    createChildren(): void {  }

}